import packageJson from '../../package.json';

export const environment = {
    production: false,
    tracking: false,
    demoOrganisationKey: '63b2fcdf-1c10-440a-b6cc-443ede0528f4',
    urlAddress: 'https://linq-systest.azurewebsites.net',
    websiteUrl: 'https://thinklikelinq.com/',
    demoBookingUrl: 'https://calendly.com/neil-calvert/chat-with-me',
    googleTagManagerID: 'GTM-5N4HJGHB',
    version: packageJson.version,
    googleClientID: '773924914282-k7jb1ouo9uimlc8n7j4pp8hh0n6lfh00.apps.googleusercontent.com',
    msalConfig: {
        auth: {
          clientId: '833ce58b-e8c6-4b33-b4b9-059fa541ff31',
          authority: 'https://login.microsoftonline.com/a7a96a44-77c9-422a-95e4-4c23ec4b5670',
        },
      },
      apiConfig: {
        scopes: ['user.read'],
        uri: 'https://graph.microsoft-ppe.com/v1.0/me',
      }
  };
  